import ReactDOM from 'react-dom';
import { App } from 'containers/root';
import './styles/index.css';

ReactDOM.render(<App />, document.getElementById('root'));
